import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function DistrictGlance({ nextStep, prevStep }) {
  return (
    <>
      <div className="form-navigator-body">
        <div className="row">
          <div className="col-lg-6">
            <div className="form-group">
              <label>District HIV prevalence rate</label>
              <input
                type="text"
                placeholder="Enter District HIV prevalence rate"
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="form-group">
              <label>Estimated no. of PLHIVs </label>
              <input
                type="text"
                placeholder="Enter Estimated no. of PLHIVs"
                // value="983	"
              />
            </div>
          </div>
        </div>

        <div className="referenceText">
          * Reference can be taken from latest SANKALAK or latest India HIV
          Estimates
        </div>
      </div>

      <div className="form-navigate-footer">
        <button onClick={prevStep} className="btn btn-outline-secondary">
          Back
        </button>
        <button onClick={nextStep} className="btn btn-dark border-0">
          Next
        </button>
      </div>
    </>
  );
}
